














import FeedbackComponent from '@/components/base/FeedbackComponent'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {ServiceApi} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

@Component({})
export default class EmployersComponent extends FeedbackComponent {

  @Prop() fakeEmployer!: any

  private searchAndAuthorizeToImpersonatePath: string = 'searchAndAuthorizeToImpersonate'
  private authorizeToImpersonatePath: string = 'authorizeToImpersonate'
  private employersPath: string = 'getEmployers'
  private getAuthorizedImpersonatorsPath: string = 'getAuthorizedImpersonators'
  private checkBoxCheckAllProperty = false;

  private searchFieldsEmployersModal: SearchFieldModel[] = []
  private columnsEmployersModal: GridColumn[] = []

  mounted() {
    this.initSearchFields()
    this.initColumns()
  }

  private initSearchFields(): void {
    this.searchFieldsEmployersModal.push({
      label: 'hp_number',
      property: 'employerHp',
      fieldType: FieldType.NUMBER_FIELD
    })
    this.searchFieldsEmployersModal.push({
      label: 'employer_name',
      property: 'employerName',
      fieldType: FieldType.TEXT_FIELD
    })
    this.searchFieldsEmployersModal.push({
      label: 'employer_number',
      property: 'employerNum',
      fieldType: FieldType.NUMBER_FIELD
    })
    this.searchFieldsEmployersModal.push({
      label: 'canImpersonateOnly',
      property: 'canImpersonateOnly',
      fieldType: FieldType.SELECT_FIELD,
      advancedOnly: true,
      selectOptions: [{
        value: true,
        description: '' + this.$t('yes')
      }],
      selectDisplay: 'description',
      unSelectFirst: true
    })

  }

  private initColumns(): void {
    this.columnsEmployersModal.push({property: 'employerHp', header: 'hp_number'} as GridColumn)
    this.columnsEmployersModal.push({property: 'employerName', header: 'employer_name'} as GridColumn)
    this.columnsEmployersModal.push({property: 'employerNum', header: 'employer_number'} as GridColumn)
  }

  onSuccess(data: any, requestName?: string, message?: string): void {

    switch (requestName) {
      case this.searchAndAuthorizeToImpersonatePath:
      case this.authorizeToImpersonatePath:
        this.showSuccessPopup();
        break
      case this.employersPath:
      case this.getAuthorizedImpersonatorsPath:
        this.$emit('successResults', data)
        break
    }
  }

  private showSuccessPopup() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'authorize_to_impersonate_succeeded',
      icon: 'checkCircle',
      secondsToDisappear: 2
    })
  }

  onProgress(requestName?: string): void {
    if (this.authorizeToImpersonatePath !== requestName)//cancel the refresh icon on 'authorizeToImpersonatePath'
    {
      this.loading = true
      this.$Progress.start()
    }
  }

  onCheckboxClick(checked: boolean, result: any): void {
    new ServiceApi()
        .setToken(this.accessToken)
        .setRequestName(this.authorizeToImpersonatePath)
        .setRequestBody({
          secUserKey: this.fakeEmployer.id,
          employerNum: result.employerNum,
          isAuthorized: checked
        })
        .post(this)
  }

  onCheckboxCheckAll(checkAll: boolean, searchObject: any) {
    searchObject.isAuthorized = checkAll
    this.checkBoxCheckAllProperty = checkAll
    new ServiceApi()
        .setToken(this.accessToken)
        .setRequestName(this.searchAndAuthorizeToImpersonatePath)
        .setPathVariable(this.fakeEmployer.id)
        .setRequestBody(searchObject)
        .post(this)
  }

  getGridEmployerDataModal(searchObject: any): void {
    searchObject.pageSize = 100
    let path = this.employersPath
    let searchObjectCopy: any = {...searchObject}
    if (searchObjectCopy.canImpersonateOnly && searchObjectCopy.canImpersonateOnly.value) {
      path = this.getAuthorizedImpersonatorsPath
    }
    delete searchObjectCopy.canImpersonateOnly
    new ServiceApi()
        .setToken(this.accessToken)
        .setPathVariable(this.fakeEmployer.id)
        .setRequestName(path)
        .setRequestBody(searchObjectCopy)
        .post(this)


  }

  closeModal(modalObj: any) {
    this.$root.$emit('closeImpersonatorsModal', modalObj)
  }
}

